import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Reports", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Reports"
  }), _hoisted_1]);
}